import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import { FaMedal} from "react-icons/fa6";
import ViewLeave from "./view";
import EditLeave from "./edit";
import { MODULE_LEAVE } from "variables/constants";
import HyvidAwards from "./index";

const hyvidAwardRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Hyvid Awards",
		basePath: "hyvid-awards",
		mainComponent: <HyvidAwards />,
	    layout: "/console",	   
	    icon: <FaMedal className="icon-item" />,
	    subTitle:"Hyvid Awards",
	    viewComponent: <ViewLeave />,
	    createComponent: <EditLeave />,
	    editComponent: <EditLeave />,
		level:5,
		moduleId: MODULE_LEAVE,
	})
]

export default hyvidAwardRoutes;